module.exports = __webpack_public_path__ + "img/text-indent-right.8fd8567f.svg";